import { Button, Typography } from "@mui/material";
import React from "react";

const ResourceButton = ({
	icon: Icon,
	label,
	onClick,
}: {
	icon: React.ElementType;
	label: React.ReactNode;
	onClick: () => void;
}) => (
	<Button
		className="sidebar__option sidebar__option--link"
		onClick={onClick}
	>
		<Icon />
		<Typography>{label}</Typography>
	</Button>
);

export default React.memo(ResourceButton);
